import { ComponentPropsWithoutRef, ReactNode } from 'react';
import { RoundedButtonContainer, RoundedButtonContent, RoundedButtonIcon } from './styles';
import PlusDarkIcon from '../../../src/images/PlusDarkIcon.svg?react';

type RoundedButtonType = {
  children: ReactNode;
  onClick: () => void;
  icon?: ReactNode;
} & ComponentPropsWithoutRef<'button'>;

export const RoundedButton = ({ children, onClick, icon, ...rest }: RoundedButtonType) => {
  const buttonIcon = icon ? icon : <PlusDarkIcon />;

  return (
    <RoundedButtonContainer onClick={onClick} {...rest}>
      <RoundedButtonContent>{children}</RoundedButtonContent>
      <RoundedButtonIcon>{buttonIcon}</RoundedButtonIcon>
    </RoundedButtonContainer>
  );
};
